export const convertPathToHREF = (
  path: string,
  base = process.env.REACT_APP_BASE_DIRECTORY
) =>
  // add base directory to path when the base is not "/"
  base !== "/" ? `${base}${path}` : path;
